export default __webpack_public_path__ + "static/media/like-filled.6dcaf848.svg";